export enum Features {
  // please keep this one at all times, is used for testing
  // and should stay even if no feature toggle is used at the moment
  FEATURE_TOGGLE_TEST = 'FEATURE_TOGGLE_TEST',
  // normal Features go here:
  GRAPHQL_GDPR_SELF_ASSESSMENT = 'GRAPHQL_GDPR_SELF_ASSESSMENT',
  MUNICH_DEMO = 'MUNICH_DEMO',
  DSBOSS_SCENARIOS_TABLE_PACE = 'DSBOSS_SCENARIOS_TABLE_PACE',
  EMERGENCY_DISABLE_SERVICE = 'EMERGENCY_DISABLE_SERVICE',
  STOP_NETWORK_IMPORTS = 'STOP_NETWORK_IMPORTS',
  KPI_DASHBOARD_ANNOTATIONS = 'KPI_DASHBOARD_ANNOTATIONS',
  KPI_DASHBOARD_AI = 'KPI_DASHBOARD_AI',
  VEHICLE_CAPACITY_CONFIG = 'VEHICLE_CAPACITY_CONFIG',
  ROAD_NETWORK_KEEP_OUT_ZONES = 'ROAD_NETWORK_KEEP_OUT_ZONES',
  AP_PRICING = 'AP_PRICING',
  FLEET_TRACING_EXPERIMENTAL = 'FLEET_TRACING_EXPERIMENTAL',
  VERIFICATION_AND_VALIDATION = 'VERIFICATION_AND_VALIDATION',
  INCIDENT_ANALYSIS_AREA = 'INCIDENT_ANALYSIS_AREA',
  VEHICLE_STATE_MACHINE = 'VEHICLE_STATE_MACHINE',
} // DONT DELETE - template injection feature

export type FeatureApp = 'backoffice' | 'admin-panel' | 'shared'

export const FEATURE_APP: Record<Features, FeatureApp> = {
  [Features.FEATURE_TOGGLE_TEST]: 'shared',
  [Features.GRAPHQL_GDPR_SELF_ASSESSMENT]: 'backoffice',
  [Features.MUNICH_DEMO]: 'backoffice',
  [Features.DSBOSS_SCENARIOS_TABLE_PACE]: 'backoffice',
  [Features.EMERGENCY_DISABLE_SERVICE]: 'backoffice',
  [Features.STOP_NETWORK_IMPORTS]: 'backoffice',
  [Features.KPI_DASHBOARD_ANNOTATIONS]: 'backoffice',
  [Features.KPI_DASHBOARD_AI]: 'backoffice',
  [Features.VEHICLE_CAPACITY_CONFIG]: 'backoffice',
  [Features.ROAD_NETWORK_KEEP_OUT_ZONES]: 'backoffice',
  [Features.AP_PRICING]: 'admin-panel',
  [Features.VERIFICATION_AND_VALIDATION]: 'admin-panel',
  [Features.FLEET_TRACING_EXPERIMENTAL]: 'backoffice',
  [Features.INCIDENT_ANALYSIS_AREA]: 'admin-panel',
  [Features.VEHICLE_STATE_MACHINE]: 'backoffice',
}
